import { createTheme } from '@kis-technologies/kis-ui';

const theme = createTheme({
  palette: {
    primary: {
      main: '#F46D2E', // Define default theme color
      contrastText: '#FFFFFF' // Used in loader
    },
    background: {
      default: '#fafafa'
    },
    error: {
      main: '#C40B0F'
    }
  },
  typography: {
    fontFamily: 'Poppins, sans-serif'
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        stickyHeader: {
          backgroundColor: '#fafafa'
        }
      }
    }
  }
});

export default theme;
